<template>
    
    <div class="puzzle-board">

        <div id="puzzle-table">

            <div
                v-for="element in boardArr"
                :key="element.id"
                class="puzzle-td dropzone"
                :id="`board-${element.id}`"
            >
            </div>
        </div>

        <div id="puzzle-list">

            <div
                v-for="image in imageArr"
                :key="image.url"
                :id="`image-${image.id}`"
                class="drag-drop"
            >

                <img 
                    :src="image.url"
                    class="drag-drop-image"
                    :id="`image-${image.id}`"
                />
            </div>
        </div>
    </div>
</template>

<script>

    import { reactive, toRefs } from "vue";

    import interactMixin from "@/mixins/interact";
    import { randomizeArr, generateArr } from "@/utils/array";

    export default {
        name: "PuzzleBoard",
        mixins: [interactMixin],
        props: {
            imageId: {
                type: String
            }
        },
        setup(props) {

            const boardArr = [];
            const imageArr = [];

            for(let i = 0; i < generateArr(9).length; i++) {

                const id = i + 1;

                boardArr.push({
                    id,
                    isAvailable: true,
                    isCorrect: false
                });

                imageArr.push({
                    id,
                    url: `./puzzleimage/${props.imageId}/img/${id}.jpg`
                });
            }

            const state = reactive({
                boardArr,
                imageArr: randomizeArr(imageArr),
                selectedImageId: ""
            });

            return {
                ...toRefs(state)
            };
        },
        mounted() {
            this.init();
        }
    };
</script>

<style lang="scss" scoped>

    @media screen and (max-height: 800px) {
        .puzzle-board {

            height: 100%;
            width: 100%;

            #puzzle-table {
                position: fixed;
                left: calc((100% - 6rem * 3) / 2);
                right: calc((100% - 6rem * 3) / 2);
                top: 23.5%;
                border-radius: 25px;
                height: calc(6rem * 3);
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                width: calc(6rem * 3);
                border: 15px solid #3095FF;
                background-color: #CBE1FF;

                div {
                    width: calc(100% / 3);
                    height: calc(100% / 3);
                    border-right: 3px solid #3095FF;
                    border-bottom: 3px solid #3095FF;
                }

                div:nth-of-type(3n) {
                    border-right: none;
                }

                div:nth-of-type(7),
                div:nth-of-type(8),
                div:nth-of-type(9) {
                    border-bottom: none;
                }
            }

            #puzzle-list {
                display: flex;
                flex-direction: row;
                align-items: flex-end;
                flex-wrap: nowrap;
                overflow-x: auto;
                position: fixed;
                bottom: 4rem;
                left: 5%;
                right: 5%;
                height: calc(42% + 90px + 28%);
                .drag-drop {
                    height: 4rem;
                    margin-right: 1rem;
                    touch-action: none;

                    .drag-drop-image {
                        width: 3rem;
                        height: 3rem;
                        box-shadow: 0 0 0 5px rgba($color: #E4F6FC, $alpha: 0.43);
                        border: 2px solid #065BF8;
                        border-radius: 5px;
                    }
                }
            }
        }
    }

    @media screen and (min-height: 800px) {
        
        .puzzle-board {

            height: 100%;
            width: 100%;

            #puzzle-table {
                position: fixed;
                left: 4%;
                right: 4%;
                top: 24%;
                border-radius: 25px;
                height: 42%;
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                width: 92%;
                border: 15px solid #3095FF;
                background-color: #CBE1FF;

                div {
                    width: calc(100% / 3);
                    height: calc(100% / 3);
                    border-right: 3px solid #3095FF;
                    border-bottom: 3px solid #3095FF;
                }

                div:nth-of-type(3n) {
                    border-right: none;
                }

                div:nth-of-type(7),
                div:nth-of-type(8),
                div:nth-of-type(9) {
                    border-bottom: none;
                }
            }

            #puzzle-list {
                display: flex;
                flex-direction: row;
                align-items: flex-end;
                flex-wrap: nowrap;
                overflow-x: auto;
                position: fixed;
                top: 9%;
                left: 5%;
                right: 5%;
                bottom: 0;
                height: calc(42% + 90px + 22%);

                .drag-drop {
                    width: 90px;
                    height: 90px;
                    margin-right: 1rem;
                    touch-action: none;

                    .drag-drop-image {
                        width: 5rem;
                        height: 5rem;
                        box-shadow: 0 0 0 5px rgba($color: #E4F6FC, $alpha: 0.43);
                        border: 2px solid #065BF8;
                        border-radius: 5px;
                    }
                }
            }
        }
    }
</style>